import { Badge } from '@/components/ui/badge'
import { STATUS_BADGES, type StepStatus } from './checkoutData'

/** A step's status beside its title; a step that hasn't started shows nothing. */
export function StepStatusBadge({ status }: { status?: StepStatus }) {
  if (!status) return null
  const { label, variant } = STATUS_BADGES[status]
  return <Badge variant={variant}>{label}</Badge>
}
